<div class="mb-3">
  @if (appealsService.messageAppealPetition == 'SUCCESS_CONTINUANCE') {
  <nh-alert type="success" [isOpen]="appealsService.showMessageAppealPetition">
    @if (appealsService.messageAppealPetition == 'SUCCESS_CONTINUANCE') {
    <div class="col message">
      <span [innerHtml]="'SUCCESS_APL_PTIN_SUBMITTED' | globalTranslate">
      </span>
    </div>
    }
  </nh-alert>
  } @if (appealsService.messageAppealPetition == 'ERROR_MESSAGE') {
  <nh-alert type="warning" [isOpen]="appealsService.showMessageAppealPetition">
    @if (appealsService.messageAppealPetition == 'ERROR_MESSAGE') {
    <div class="col message">
      <span>{{ "ERROR_APL_PTIN_SUBMITTED" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  }
  <div class="bg-custom">
    <div class="container">
      <div>
        <h1 class="section-header">
          {{ "APL_PTIN_FORM_TITLE" | globalTranslate }}
        </h1>
        <hr />
        <div>
          <p class="mb-4">{{ "APL_PTIN_SUBMISSION_MSG" | globalTranslate }}</p>
        </div>
        <div>
          <form [formGroup]="appealPetitionSubmissionForm">
            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_submittedby"
              [mandatory]="true"
              label="{{ 'SUBMITTEDBY_CONTINUANCE' | globalTranslate }}"
              [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
            >
              <div>
                <p class="note_padding">
                  {{ "APL_PTIN_SUBMISSION_NOTE_SUBMITTEDBY" | globalTranslate }}
                </p>
              </div>
              <input
                type="text"
                class="form-control"
                name="submittedBy"
                formControlName="submittedBy"
                [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
                autofocus="true"
                maxlength="30"
              />
            </nh-field>
            <p></p>

            <nh-field
              [attr.aria-required]="true"
              [isRow]="true"
              [mandatory]="true"
              label="{{ 'PHONE_NUMBER_WITHDRAWAL' | globalTranslate }}"
              [attr.aria-label]="'PHONE_NUMBER_WITHDRAWAL' | globalTranslate"
            >
              <input
                type="text"
                name="phoneNumber"
                formControlName="phoneNumber"
                [attr.aria-label]="'PHONE_NUMBER_WITHDRAWAL' | globalTranslate"
                class="form-control mt-2"
                mask="000-000-0000"
                placeholder="XXX-XXX-XXXX"
              />
            </nh-field>

            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_relationship"
              [mandatory]="true"
              label="{{ 'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate }}"
              [attr.aria-label]="
                'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
              "
            >
              <div>
                <p class="rel_pad">
                  {{ "APL_PTIN_NOTE_RELATIONSHIP" | globalTranslate }}
                </p>
              </div>
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="relationshipWithAppellant"
                  formControlName="relationshipWithAppellant"
                  [attr.aria-label]="
                    'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>

            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_comments"
              [mandatory]="true"
              label="{{ 'APL_PTIN_RESPONSE' | globalTranslate }}"
              [attr.aria-label]="'APL_PTIN_RESPONSE' | globalTranslate"
            >
              <div>
                <p
                  class="rel_pad"
                  [innerHtml]="'APL_PTIN_RESPONSE_NOTE' | globalTranslate"
                ></p>
              </div>
              <nh-count>
                <textarea
                  maxlength="4000"
                  class="form-control"
                  name="appealPetitionResponse"
                  formControlName="appealPetitionResponse"
                  [attr.aria-label]="'APL_PTIN_RESPONSE' | globalTranslate"
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>
          </form>

          <div class="row my-1">
            <div class="col-md-12">
              <div
                class="row mt-3 text-center py-3"
                style="padding-top: 0.5rem !important"
              >
                <div class="ms-3">
                  <button
                    id="continue"
                    class="btn d-grid btn-secondary btn-width"
                    [disabled]="appealsService.showMessageAppealPetition"
                    (click)="
                      onSubmit(
                        this.appealPetitionSubmissionForm.controls,
                        this.translatedLang
                      )
                    "
                    [disabled]="!isFormValid()"
                  >
                    {{ "SUBMIT_APL_PTIN_BTN" | globalTranslate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-12">
      <div class="row mt-3 text-center py-4 withdrawl-exit">
        <div class="ms-3">
          <button
            id="continue"
            class="btn d-grid btn-secondary btn-width"
            (click)="goToAppealsDashboard()"
          >
            {{ "EXIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>